module.exports = __webpack_public_path__ + "img/lg_ring_skip_0_1_1.78423c00.png";